<script setup lang="ts">
import { computed } from 'vue'

interface Props {
    primary?: boolean
    secondary?: boolean
    muted?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    primary: false,
    secondary: false,
    muted: false,
})

const classes = computed(() => [
    'mloading',
    {
        'mloading--primary': props.primary,
        'mloading--secondary': props.secondary,
        'mloading--muted': props.muted,
    },
])
</script>

<template>
    <svg :class="classes" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="mloading__circle" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path
            class="mloading__path"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
    </svg>
</template>
